import Table from "../../../component/table/Table";
import tableData from "../../../utils/logistica/manutenzioneLogisticaData.json";
import { useEffect, useState } from "react";
import { fetchManutenzione } from "../../../features/manutenzione/manutenzioneThunk";
import { useDispatch, useSelector } from "react-redux";
import { se } from "date-fns/locale";

const Manutenzione = () => {
    const selectSelectedCompany = useSelector((state) => state.company.selectedCompany);
    const dispatch = useDispatch()
    const manutenzione = useSelector((state) => state.manutenzione?.manutenzione);
    const loading = useSelector((state) => state.manutenzione?.loading)
    const columns = [
        { field: "intervento", headerName: "Intervento", width: 596 },
        { field: "tipoDiIntervento", headerName: "Tipo", width: 261 },
        { field: "km_mezzo", headerName: "Km mezzo", width: 136 },
        { field: "dataIntervento", headerName: "Data", width: 124 },
        { field: "stato_intervento", headerName: "Stato", width: 157 },
        { field: "azioni", headerName: "Azioni", width: 60, sortable: false }
    ];

    const [tableRows, setTableRows] = useState([])

    useEffect(() => {
        dispatch(fetchManutenzione())
        
    }, [dispatch, selectSelectedCompany])

    useEffect(() => {
        // if (manutenzione && manutenzione.length > 0) {

            const mappedData = manutenzione.map((item) => ({
                id:item.id,
                intervento: item?.intervento,
                tipoDiIntervento: item?.tipo_di_intervento,
                dataIntervento: item?.data_intervento,
                km_mezzo: item?.km_mezzo,
                stato_intervento: item?.stato_intervento,
            }))
            setTableRows(mappedData)
        // }
    }, [manutenzione])
    return (
        <>
            <div className="pageTemplate">
                {loading ? (
                    <div>Loading...</div> // You can show a loading spinner or message while fetching data
                ) : (
                    <Table
                        data={tableRows}
                        columns={columns}
                        navData={"manutenzioneLogistica"}
                        deleteFunctions={"deleteManutenzioneData"}
                    />
                )}
            </div>
        </>
    );
};

export default Manutenzione;
